import React from 'react';
import { Path, Svg } from 'react-native-svg';
import { useUnistyles } from 'react-native-unistyles';

import type { AppColors } from '@squire/ui';

interface ResendIconProps {
  size?: number;
  color?: keyof AppColors;
}

export const ResendIcon: React.FC<ResendIconProps> = ({
  size = 16,
  color = 'iconPrimary',
}) => {
  const { theme: colors } = useUnistyles();

  return (
    <Svg width={size} height={size} viewBox="0 0 16 16">
      <Path
        d="M15.4854 7.18245H14.58C14.1875 4.0428 11.3954 1.5 8.00176 1.5C6.20366 1.5 4.56384 2.25227 3.41154 3.41487C3.05065 3.73816 3.05065 4.1858 3.31024 4.45313C3.57616 4.73912 4.00669 4.78886 4.40556 4.45313C5.31094 3.53922 6.58987 2.96102 8.00176 2.96102C10.6103 2.96102 12.6996 4.82616 13.0795 7.18245H12.0918C11.5853 7.18245 11.4334 7.58034 11.7436 8.00311L13.3454 10.1853C13.5923 10.5273 13.9849 10.5273 14.2381 10.1853L15.8336 8.00311C16.1502 7.58034 16.0046 7.18245 15.4854 7.18245ZM0.511786 8.81755H1.42983C1.82237 11.9572 4.6145 14.5 8.00176 14.5C9.81253 14.5 11.4523 13.7477 12.6046 12.5851C12.9592 12.2556 12.9592 11.808 12.7059 11.5407C12.4337 11.2547 12.0095 11.2111 11.6043 11.5469C10.7052 12.4608 9.42632 13.039 8.00176 13.039C5.39958 13.039 3.31024 11.1801 2.93036 8"
        fill={colors[color]}
      />
    </Svg>
  );
};
